import Vue from "vue";
import Vuetify from "vuetify/lib/framework";
import colors from "vuetify/lib/util/colors";
Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: "mdi",
  },

  theme: {
    dark: false,
    themes: {
      light: {
        primary:"#0E1832",
        secondary: "#1A2C59",
        light: "#C4CCDF",
        accent: colors.pink.darken1,
        error: colors.red.accent3,
        background: "#fff",
        info: colors.teal.darken1,
      },
      dark: {
        primary: "#fff",
        background: "#1A2C59",
        info: colors.teal.lighten1,
      },
    },
  },
});
